<template>
  <div>
    <el-card>
      <el-form ref="form" :inline="true">
        <el-form-item label="时间">
          <el-date-picker
            type="datetimerange"
            v-model="times"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toQuery" icon="el-icon-search"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        :data="courseAppointmentList"
        stripe
        class="table"
        ref="userTable.multipleSelection"
        header-cell-class-name="table-header"
        border
      >
        <el-table-column
          prop="id"
          label="ID"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column label="用户名" prop="userInfo.nickname" align="center"></el-table-column>
        <el-table-column label="预约开始时间" prop="start_time" align="center"></el-table-column>
        <el-table-column label="预约结束时间" prop="end_time" align="center"></el-table-column>
        <!-- <el-table-column label="预约时长" prop="cost_time" align="center"></el-table-column> -->
        <el-table-column label="报名课程" prop="goodsInfo.goods_name" align="center"></el-table-column>
        <el-table-column label="老师用户名" prop="teacherInfo.username" align="center"></el-table-column>
        <el-table-column label="状态" prop="state" align="center">
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="el-icon-message-solid"
              circle
              @click="editGoods(scope.row)"
              size="small"
              v-if="scope.row.state == 1"
            ></el-button>
            <el-button
              type="primary"
              icon="el-icon-check"
              circle
              @click="title(2)"
              size="small"
              v-if="scope.row.state == 2"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-close"
              circle
              @click="title(-1)"
              size="small"
              v-if="scope.row.state == -1"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>

       <!-- 分页区域 -->
     <div class="pagination">
       <span></span>
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.page"
        :page-sizes="[3, 5, 8, 10]"
        :page-size="queryForm.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        algin:="center"
      ></el-pagination>
     </div>

     <!-- 操作弹窗 -->
      <el-dialog title="是否接受预约？" :visible.sync="addDialog" :center=true width="40%" @close="closed" :close-on-click-modal=false>
      <el-form ref="addForm">
        <el-form-item el-form-item label="原因" label-width="100px">
            <el-input
              v-model="reason"
              placeholder="请输入原因"
            />
        </el-form-item>
        <el-form-item label-width=40% style="margin-top: 20px;">
           <el-button type="primary" @click="confirm" >接受</el-button>
           <el-button type="primary" @click="cancel">拒绝</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  getCourseAppointment,
  editCourseAppointment,
} from "@/api/onetooneAppointment.js";
import store from "@/store";
export default {
  data() {
    return {
      addDialog: false,
      times: null,
      queryForm: {
        page: 1,
        limit: 10,
        start_time: null,
        end_time: null,
        type: 1,
      },
      courseAppointmentList: [],
      total: 0,
      state: null,
      reason: "",
      id: null
    };
  },

  created() {
    this.getAppointmentList();
  },
  methods: {
    //预约列表
    getAppointmentList() {
      getCourseAppointment(this.queryForm).then((res) => {
        if (res.code !== 1) {
          this.$message.error(res.msg);
          return;
        }
        this.total = res.data.total;
        this.courseAppointmentList = res.data.data;
      });
    },

    // 点击编辑图标
    editGoods(item) {
      console.log(item)
      this.addDialog = true;
      this.id = item.id;
    },

    // 点击接受预约
    confirm() {
      let confirmData = {
        id: this.id,
        state: 2,
        reason: this.reason
      }
      console.log(confirmData)
      editCourseAppointment(confirmData).then((res)=>{
        if (res.code !== 1) {
          this.$message.error(res.msg);
          return;
        }
        this.$message.success("您已接受预约！");
        this.addDialog = false;
        this.getAppointmentList();
        store.commit("changeNumJapanese", 0);
      })
    },
    // 点击拒绝预约
    cancel(){
      if(this.reason == ""){
        this.$message.error("请输入拒绝理由");
        return;
      }
      let cancelData = {
        id: this.id,
        state: -1,
        reason: this.reason
      }
      console.log(cancelData)
      editCourseAppointment(cancelData).then((res)=>{
        if (res.code !== 1) {
          this.$message.error(res.msg);
          return;
        }
        this.$message.success("您已拒绝预约！");
        this.addDialog = false;
        this.getAppointmentList();
        store.commit("changeNumJapanese", 0);
      })
    },
    // 提醒
    title(value){
      if(value == 2){
        this.$message.info("您已接受预约，不能再修改！");
      }else if(value == -1){
        this.$message.info("您已拒绝预约，不能再修改！");
      }
    },
    // 弹窗关闭事件
    closed() {
      this.reason = ""
    },

    //  查询
    toQuery() {
      this.queryForm.page = 1;
      if (this.times) {
        this.queryForm.start_time = new Date(this.times[0]).getTime() / 1000;
        this.queryForm.end_time = new Date(this.times[1]).getTime() / 1000;
      } else if (this.times == null) {
        this.queryForm.start_time = null;
        this.queryForm.end_time = null;
      }
      this.getAppointmentList();
    },
    handleSizeChange(size) {
      this.queryForm.limit = size;
      this.getAppointmentList() ;
    },
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getAppointmentList() ;
    },
  },
};
</script>

<style scoped lang="less">
.generate {
  float: right;
}
.el-tag {
  cursor: pointer;
}
::v-deep .ql-editor {
  min-height: 400px;
}
.thumb_box {
  width: 100%;
  height: 100%;
  img {
    width: 120px;
    height: 200px;
  }
}

.tips {
  color: red;
}
::v-deep .el-upload--text {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
